import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    apellido: '',
    nombre: '',
    documentoTipoId: 0,
    documentoTipo: null,
    documentoTipoNombre: null,
    documentoNumero: '',
    paisId: 0,
    pais: null,
    paisNombre: null,
    provinciaId: 0,
    provincia: null,
    provinciaNombre: null,
    localidadId: 0,
    localidad: null,
    localidadNombre: null,
    direccion: '',
    codigoPostal: '',
    celular: '',
    email: '',
    celularTrabajo: '',
    emailTrabajo: '',
    contacto: '',
    telefonoContacto: '',
    fechaNacimiento: new Date(),
    fechaNacimientoHabilitada: false,
    estadoCivilId: 0,
    estadoCivil: null,
    estadoCivilNombre: null,
    fechaIngreso: new Date(),
    fechaIngresoHabilitada: false,
    fechaEgreso: new Date(),
    fechaEgresoHabilitada: false,
    condicionFiscalId: 0,
    condicionFiscal: null,
    condicionFiscalNombre: null,
    tipoIdentificacionTributariaId: 0,
    tipoIdentificacionTributaria: null,
    tipoIdentificacionTributariaNombre: null,
    codigoIdentificacionTributaria: '',
    // cuit: '',
    bancoId: 0,
    banco: null,
    bancoNombre: null,
    numeroCuenta: '',
    cbu: '',
    cbuAlias: '',
    cargoId: 0,
    cargo: null,
    cargoNombre: null,
    externo: false,
    socio: false,
    facturaHonorarios: false,
    proveedorId: 0,
    proveedor: null,
    proveedorNombre: null,

    // computadora: false,
    // computadoraMarca: '',
    // computadoraNumeroSerie: '',
    // telefono: false,
    // telefonoMarca: '',
    // telefonoIMEI: '',
    // telefonoNumero: '',
    silla: false,
    mouse: false,
    headset: false,

    observaciones: '',
    hijos: [],
    usuarioId: 0,
    usuario: null,
    usuarioNombre: null,
    rowVersion: null,

    hijoSeleccionado: null,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, personalId) {
        let fecha = moment(new Date()).format('YYYY-MM-DD');

        state.id = personalId;
        state.apellido = '';
        state.nombre = '';
        state.documentoTipoId = 0;
        state.documentoTipo = null;
        state.documentoTipoNombre = null;
        state.documentoNumero = '',
        state.paisId = 0;
        state.pais = null;
        state.paisNombre = null;
        state.provinciaId = 0;
        state.provincia = null;
        state.provinciaNombre = null;
        state.localidadId = 0;
        state.localidad = null;
        state.localidadNombre = null;
        state.direccion = '';
        state.codigoPostal = '';
        state.celular = '';
        state.email = '';
        state.celularTrabajo = '';
        state.emailTrabajo = '';
        state.contacto = '';
        state.telefonoContacto = '';
        state.fechaNacimiento = fecha;
        state.fechaNacimientoHabilitada = false;
        state.estadoCivilId = 0;
        state.estadoCivil = null;
        state.estadoCivilNombre = null;
        state.fechaIngreso = fecha;
        state.fechaIngresoHabilitada = false;
        state.fechaEgreso = fecha;
        state.fechaEgresoHabilitada = false;
        state.condicionFiscalId = 0;
        state.condicionFiscal = null;
        state.condicionFiscalNombre = null;
        state.tipoIdentificacionTributariaId = 0;
        state.tipoIdentificacionTributaria = null;
        state.tipoIdentificacionTributariaNombre = null;
        state.codigoIdentificacionTributaria = '',
        // state.cuit = '';
        state.bancoId = 0;
        state.banco = null;
        state.bancoNombre = null;
        state.numeroCuenta = '';
        state.cbu = '';
        state.cbuAlias = '';
        state.cargoId = 0;
        state.cargo = null;
        state.cargoNombre = null;
        state.externo = false;
        state.socio = false;
        state.facturaHonorarios = false;
        state.proveedorId = 0;
        state.proveedor = null;
        state.proveedorNombre = null;
        // state.computadora = false;
        // state.computadoraMarca = '';
        // state.computadoraNumeroSerie = '';
        // state.telefono = false;
        // state.telefonoMarca = '';
        // state.telefonoIMEI = '';
        // state.telefonoNumero = '';
        state.silla = false;
        state.mouse = false;
        state.headset = false;
        state.observaciones = '';
        state.hijos = [];
        state.usuarioId = 0;
        state.usuario = null;
        state.usuarioNombre = null;
        state.rowVersion = null;
    },
    'SET_PERSONAL' (state, personal) {
        state.apellido = personal.apellido.trim();
        state.nombre = personal.nombre.trim();
        state.documentoTipoId = personal.documentoTipo? parseInt(personal.documentoTipo.id) : 0;
        state.documentoTipo = personal.documentoTipo;
        state.documentoTipoNombre = personal.documentoTipo? personal.documentoTipo.nombre.trim() : null;
        state.documentoNumero = personal.documentoNumero.trim();
        state.paisId = personal.paisId;
        state.pais = personal.pais;
        state.paisNombre = personal.pais? personal.pais.nombre.trim() : null;
        state.provinciaId = personal.provinciaId;
        state.provincia = personal.provincia;
        state.provinciaNombre = personal.provincia? personal.provincia.nombre.trim() : null;
        state.localidadId = personal.localidadId;
        state.localidad = personal.localidad;
        state.localidadNombre = personal.localidad? personal.localidad.nombre.trim() : null;
        state.direccion = personal.direccion.trim();
        state.codigoPostal = personal.codigoPostal.trim();
        state.celular = personal.celular.trim();
        state.email = personal.email.trim();
        state.celularTrabajo = personal.celularTrabajo.trim();
        state.emailTrabajo = personal.emailTrabajo.trim();
        state.contacto = personal.contacto.trim();
        state.telefonoContacto = personal.telefonoContacto.trim();
        state.fechaNacimiento = moment(personal.fechaNacimiento).format('YYYY-MM-DD');
        if (moment(personal.fechaNacimiento).format('YYYY-MM-DD') != '1900-01-01') {
            state.fechaNacimientoHabilitada = true;
        } else {
            state.fechaNacimientoHabilitada = false;   
        }
        state.estadoCivilId = personal.estadoCivil? parseInt(personal.estadoCivil.id) : 0;
        state.estadoCivil = personal.estadoCivil;
        state.estadoCivilNombre = personal.estadoCivil? personal.estadoCivil.nombre.trim() : null;
        state.fechaIngreso = moment(personal.fechaIngreso).format('YYYY-MM-DD');
        if (moment(personal.fechaIngreso).format('YYYY-MM-DD') != '1900-01-01') {
            state.fechaIngresoHabilitada = true;
        } else {
            state.fechaIngresoHabilitada = false;
        }
        state.fechaEgreso = moment(personal.fechaEgreso).format('YYYY-MM-DD');
        if (moment(personal.fechaEgreso).format('YYYY-MM-DD') != '1900-01-01') {
            state.fechaEgresoHabilitada = true;
        } else {
            state.fechaEgresoHabilitada = false;
        }
        state.condicionFiscalId = personal.condicionFiscal? parseInt(personal.condicionFiscal.id) : 0;
        state.condicionFiscal = personal.condicionFiscal;
        state.condicionFiscalNombre = personal.condicionFiscal? personal.condicionFiscal.nombre.trim() : null;
        state.tipoIdentificacionTributariaId = personal.tipoIdentificacionTributaria? parseInt(personal.tipoIdentificacionTributaria.id) : 0;
        state.tipoIdentificacionTributaria = personal.tipoIdentificacionTributaria;
        state.tipoIdentificacionTributariaNombre = personal.tipoIdentificacionTributaria? personal.tipoIdentificacionTributaria.nombre.trim() : null;
        state.codigoIdentificacionTributaria = personal.codigoIdentificacionTributaria.trim();
        // state.cuit = personal.cuit.trim();
        state.bancoId = personal.banco? parseInt(personal.banco.id) : 0;
        state.banco = personal.banco;
        state.bancoNombre = personal.banco? personal.banco.nombre.trim() : null;
        state.numeroCuenta = personal.numeroCuenta.trim();
        state.cbu = personal.cbu.trim();
        state.cbuAlias = personal.cbuAlias.trim();
        state.cargoId = personal.cargo? personal.cargo.id : 0;
        state.cargo = personal.cargo;
        state.cargoNombre = personal.cargo? personal.cargo.nombre.trim() : null;
        state.externo = (/true/i).test(personal.externo);
        state.socio = (/true/i).test(personal.socio);
        state.facturaHonorarios = (/true/i).test(personal.facturaHonorarios);
        state.proveedorId = personal.proveedorId;
        state.proveedor = personal.proveedor;
        state.proveedorNombre = personal.proveedor? personal.proveedor.nombre.trim() : null;
        // state.computadora = (/true/i).test(personal.computadora);
        // state.computadoraMarca = personal.computadoraMarca.trim();
        // state.computadoraNumeroSerie = personal.computadoraNumeroSerie.trim();
        // state.telefono = (/true/i).test(personal.telefono);
        // state.telefonoMarca = personal.telefonoMarca.trim();
        // state.telefonoIMEI = personal.telefonoIMEI.trim();
        // state.telefonoNumero = personal.telefonoNumero.trim();
        state.silla = (/true/i).test(personal.silla);
        state.mouse = (/true/i).test(personal.mouse);
        state.headset = (/true/i).test(personal.headset);
        state.observaciones = personal.observaciones.trim();
        state.hijos = personal.hijos;
        state.usuarioId = personal.usuario? parseInt(personal.usuario.id) : 0;
        state.usuario = personal.usuario;
        state.usuarioNombre = personal.usuario? personal.usuario.nombre.trim() : null;
        state.rowVersion = personal.rowVersion;
    },
    'SET_PAIS'(state, pais) {
        state.pais = pais;
        if (pais) {
            state.paisId = pais.id? pais.id : 0;
            state.paisNombre = pais.nombre? pais.nombre.trim() : null;
        } else {
            state.paisId = 0;
            state.paisNombre = null;
        }
        state.provinciaId = 0;
        state.provincia = null;
        state.provinciaNombre = null;
        state.localidadId = 0;
        state.localidad = null;
        state.localidadNombre = null;
    },
    'SET_PROVINCIA'(state, provincia) {
        state.provincia = provincia;
        if (provincia) {
            state.provinciaId = provincia.id? provincia.id : 0;
            state.provinciaNombre = provincia.nombre? provincia.nombre.trim() : null;
        } else {
            state.provinciaId = 0;
            state.provinciaNombre = null;
        }
        state.localidadId = 0;
        state.localidad = null;
        state.localidadNombre = null;
    },
    'SET_LOCALIDAD'(state, localidad) {
        state.localidad = localidad;
        if (localidad) {
            state.localidadId = localidad.id? localidad.id : 0;
            state.localidadNombre = localidad.nombre? localidad.nombre.trim() : null;
        } else {
            state.localidadId = 0;
            state.localidadNombre = null;
        }
    },
    'SET_DOCUMENTO_TIPO'(state, documentoTipo) {
        state.documentoTipo = documentoTipo;
        if (documentoTipo) {
            state.documentoTipoId = documentoTipo.id? documentoTipo.id : 0;
            state.documentoTipoNombre = documentoTipo.nombre? documentoTipo.nombre.trim() : null;
        } else {
            state.documentoTipoId = 0;
            state.documentoTipoNombre = null;
        }
    },
    'SET_TIPO_IDENTIFICACION_TRIBUTARIA'(state, tipoIdentificacionTributaria) {
        state.tipoIdentificacionTributaria = tipoIdentificacionTributaria;
        if (tipoIdentificacionTributaria) {
            state.tipoIdentificacionTributariaId = tipoIdentificacionTributaria.id? tipoIdentificacionTributaria.id : 0;
            state.tipoIdentificacionTributariaNombre = tipoIdentificacionTributaria.nombre? tipoIdentificacionTributaria.nombre.trim() : null;
        } else {
            state.tipoIdentificacionTributariaId = 0;
            state.tipoIdentificacionTributariaNombre = null;
        }
    },
    'SET_ESTADO_CIVIL'(state, estadoCivil) {
        state.estadoCivil = estadoCivil;
        if (estadoCivil) {
            state.estadoCivilId = estadoCivil.id? estadoCivil.id : 0;
            state.estadoCivilNombre = estadoCivil.nombre? estadoCivil.nombre.trim() : null;
        } else {
            state.estadoCivilId = 0;
            state.estadoCivilNombre = null;
        }
    },
    'SET_CONDICION_FISCAL'(state, condicionFiscal) {
        state.condicionFiscal = condicionFiscal;
        if (condicionFiscal) {
            state.condicionFiscalId = condicionFiscal.id? condicionFiscal.id : 0;
            state.condicionFiscalNombre = condicionFiscal.nombre? condicionFiscal.nombre.trim() : null;
        } else {
            state.condicionFiscalId = 0;
            state.condicionFiscalNombre = null;
        }
    },
    'SET_BANCO'(state, banco) {
        state.banco = banco;
        if (banco) {
            state.bancoId = banco.id? banco.id : 0;
            state.bancoNombre = banco.nombre? banco.nombre.trim() : null;
        } else {
            state.bancoId = 0;
            state.bancoNombre = null;
        }
    },
    'SET_USUARIO'(state, usuario) {
        state.usuario = usuario;
        if (usuario) {
            state.usuarioId = usuario.id? usuario.id : 0;
            state.usuarioNombre = usuario.nombre? usuario.nombre.trim() : null;
        } else {
            state.usuarioId = 0;
            state.usuarioNombre = null;
        }
    },
    'SET_CARGO'(state, cargo) {
        state.cargo = cargo;
        if (cargo) {
            state.cargoId = cargo.id? cargo.id : 0;
            state.cargoNombre = cargo.nombre? cargo.nombre.trim() : null;
        } else {
            state.cargoId = 0;
            state.cargoNombre = null;
        }
    },
    'SET_PROVEEDOR'(state, proveedor) {
        state.proveedor = proveedor;
        if (proveedor) {
            state.proveedorId = proveedor.id? proveedor.id : 0;
            state.proveedorNombre = proveedor.nombre? proveedor.nombre.trim() : null;
        } else {
            state.proveedorId = 0;
            state.proveedorNombre = null;
        }
    },
    'SELECCIONAR_HIJO'(state, hijo) {
        state.hijoSeleccionado = hijo;
    },
    'ACTUALIZAR_HIJO'(state, hijo) {
        if (state.hijoSeleccionado) {
            state.hijoSeleccionado.apellido = hijo.apellido;
            state.hijoSeleccionado.nombre = hijo.nombre;
            state.hijoSeleccionado.documentoTipoId = hijo.documentoTipoId;
            state.hijoSeleccionado.documentoTipo = hijo.documentoTipo;
            state.hijoSeleccionado.documentoNumero = hijo.documentoNumero;
            state.hijoSeleccionado.fechaNacimiento = hijo.fechaNacimiento;
            state.hijoSeleccionado.edad = hijo.edad;
        } else {
            state.hijos.push(hijo);
        }
    },
    'ELIMINAR_HIJO'(state, hijo) {
        let itemKey = state.hijos
            .findIndex(h => h == hijo);

        if (itemKey != -1) {
            state.hijos.splice(itemKey, 1);
        }
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, personalId ) {
        return new Promise((resolve, reject) => { 
            commit('INICIALIZAR', personalId);

            if (personalId != 0)
            {
                apiAxios.get(`personal/${personalId}/abm` ) 
                    .then(res => {
                        commit('SET_PERSONAL', res.data);
                        resolve()
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let fechaNacimiento = '1900-01-01';
            if ((/true/i).test(state.fechaNacimientoHabilitada)) {
                fechaNacimiento = moment(state.fechaNacimiento).format('YYYY-MM-DD');
            }
            let fechaIngreso = '1900-01-01';
            if ((/true/i).test(state.fechaIngresoHabilitada)) {
                fechaIngreso = moment(state.fechaIngreso).format('YYYY-MM-DD');
            }
            let fechaEgreso = '1900-01-01';
            if ((/true/i).test(state.fechaEgresoHabilitada)) {
                fechaEgreso = moment(state.fechaEgreso).format('YYYY-MM-DD');
            }

            let hijos = state.hijos.map(hijo => ({
                apellido: hijo.apellido.toUpperCase().trim(),
                nombre: hijo.nombre.toUpperCase().trim(),
                documentoTipoId: parseInt(hijo.documentoTipoId),
                documentoNumero: hijo.documentoNumero,
                fechaNacimiento: hijo.fechaNacimiento,
            }))

            let proveedorId = state.proveedorId;
            if (!(/true/i).test(state.facturaHonorarios)) {
                proveedorId = 0;
            }

            let personal= {
                apellido: state.apellido.toUpperCase().trim(),
                nombre: state.nombre.toUpperCase().trim(),
                documentoTipoId: parseInt(state.documentoTipoId),
                documentoNumero: state.documentoNumero,
                paisId: parseInt(state.paisId),
                provinciaId: parseInt(state.provinciaId),
                localidadId: parseInt(state.localidadId),
                direccion: state.direccion.toUpperCase().trim(),
                codigoPostal: state.codigoPostal.toUpperCase().trim(),
                celular: state.celular.toUpperCase().trim(),
                email: state.email.toLowerCase().trim(),
                celularTrabajo: state.celularTrabajo.toUpperCase().trim(),
                emailTrabajo: state.emailTrabajo.toLowerCase().trim(),
                contacto: state.contacto.toUpperCase().trim(),
                telefonoContacto: state.telefonoContacto.toUpperCase().trim(),
                fechaNacimiento: fechaNacimiento,
                estadoCivilId: parseInt(state.estadoCivilId),
                fechaIngreso: fechaIngreso,
                fechaEgreso: fechaEgreso,
                condicionFiscalId: parseInt(state.condicionFiscalId),
                tipoIdentificacionTributariaId: parseInt(state.tipoIdentificacionTributariaId),
                codigoIdentificacionTributaria: state.codigoIdentificacionTributaria.toUpperCase().trim(),
                //cuit: state.cuit,
                bancoId: parseInt(state.bancoId),
                numeroCuenta: state.numeroCuenta.toUpperCase().trim(),
                cbu: state.cbu.toUpperCase().trim(),
                cbuAlias: state.cbuAlias.toUpperCase().trim(),
                cargoId: parseInt(state.cargoId),
                externo: (/true/i).test(state.externo),
                socio: (/true/i).test(state.socio),
                facturaHonorarios: (/true/i).test(state.facturaHonorarios),
                proveedorId,
                // computadora: (/true/i).test(state.computadora),
                // computadoraMarca: (/true/i).test(state.computadora) ? state.computadoraMarca.toUpperCase().trim() : '',
                // computadoraNumeroSerie: (/true/i).test(state.computadora) ? state.computadoraNumeroSerie.toUpperCase().trim() : '',
                // telefono: (/true/i).test(state.telefono),
                // telefonoMarca: (/true/i).test(state.telefono) ? state.telefonoMarca.toUpperCase().trim() : '',
                // telefonoIMEI: (/true/i).test(state.telefono) ? state.telefonoIMEI.toUpperCase().trim() : '',
                // telefonoNumero: (/true/i).test(state.telefono) ? state.telefonoNumero.toUpperCase().trim() : '',
                silla: (/true/i).test(state.silla),
                mouse: (/true/i).test(state.mouse),
                headset: (/true/i).test(state.headset),
                observaciones: state.observaciones.toUpperCase().trim(),
                hijos,
                usuarioId: state.usuarioId
            }

            let url = 'personal';
            if (state.id != 0) {
                personal.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }
            apiAxios.post(url, personal)
                .then( () => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setPais: ({commit}, pais) => {
        commit('SET_PAIS', pais);
    },
    setProvincia: ({commit}, provincia) => {
        commit('SET_PROVINCIA', provincia);
    },
    setLocalidad: ({commit}, localidad) => {
        commit('SET_LOCALIDAD', localidad);
    },
    setDocumentoTipo: ({commit}, documentoTipo) => {
        commit('SET_DOCUMENTO_TIPO', documentoTipo);
    },
    setTipoIdentificacionTributaria: ({commit}, tipoIdentificacionTributaria) => {
        commit('SET_TIPO_IDENTIFICACION_TRIBUTARIA', tipoIdentificacionTributaria);
    },
    setEstadoCivil: ({commit}, estadoCivil) => {
        commit('SET_ESTADO_CIVIL', estadoCivil);
    },
    setCondicionFiscal: ({commit}, condicionFiscal) => {
        commit('SET_CONDICION_FISCAL', condicionFiscal);
    },
    setBanco: ({commit}, banco) => {
        commit('SET_BANCO', banco);
    },
    setUsuario: ({commit}, usuario) => {
        commit('SET_USUARIO', usuario);
    },
    setCargo: ({commit}, cargo) => {
        commit('SET_CARGO', cargo);
    },
    setProveedor: ({commit}, proveedor) => {
        commit('SET_PROVEEDOR', proveedor);
    },
    seleccionarHijo: ({commit}, hijo) => {
        commit('SELECCIONAR_HIJO', hijo);
    },
    actualizarHijo: ({commit}, hijo) => {
        commit('ACTUALIZAR_HIJO', hijo);
    },
    eliminarHijo: ({commit}, hijo) => {
        commit('ELIMINAR_HIJO', hijo);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}